/* Initial values */
let didScroll;
let lastScrollTop = 0;
const delta = 5;
const header = document.querySelector('header');
const headerHeight = header.offsetHeight;

const body = document.querySelector('body');
const nav = document.querySelector('header > .toolbar > nav');
const menuToggle = document.getElementById('menu-toggle');
const menuToggleSpan = menuToggle && menuToggle.querySelector('.menu-txt');

window.onscroll = () => {
    didScroll = true;
};

const headerHasScrolled = () => {
    const st = document.body.scrollTop || document.documentElement.scrollTop;

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - st) <= delta) return;

    if (st > lastScrollTop && st > headerHeight) {
        // Scroll Down
        header.classList.add('header-up');
    } else {
        // Scroll Up
        if (st + window.innerHeight < document.body.clientHeight) {
            header.classList.remove('header-up');
        }
    }

    lastScrollTop = st;
};
const menuToggleHandler = () => {
    if (nav.classList.contains('visible')) {
        body.style.overflow = null;
        nav.classList.remove('visible');
        if (menuToggleSpan) {
            menuToggle.classList.remove('is-closable');
            menuToggle.setAttribute('aria-expanded', false);
        }
    } else {
        body.style.overflow = 'hidden';
        nav.classList.add('visible');
        if (menuToggleSpan) {
            menuToggle.classList.add('is-closable');
            menuToggle.setAttribute('aria-expanded', true);
        }
    }
};

setInterval(() => {
    if (didScroll) {
        headerHasScrolled();
        didScroll = false;
    }
}, 250);
/* Hide header on scroll down, show on scroll up end */

/* Toggle mobile menu start */
menuToggle && menuToggle.addEventListener('click', menuToggleHandler);
/* Header block end */
